<template>
  <img
    src="/assets/normandie.svg"
    alt=""
    width="900"
    height="600"
    class="ml-[0.02em] inline-block h-[0.72em] w-auto rounded-[0.1em] align-[-0.04em] ring-2 ring-white"
  >
</template>
